module.exports = __webpack_public_path__ + "static/media/LOGO GRENTON.ef31a118.png";